import React from "react";
import CardComponent from "./CardComponent";
import TableComponent from "./TableComponent";

const FinancialCard = ({data = []}) => {
    // First row: cards where type is NOT defined
    const firstRowCards = data.filter(c => !c.type);

    // Second row: cards where type IS defined
    const secondRowCards = data.filter(c => c.type);

    return (
        <>
            {/* First Row */}
            {firstRowCards.length > 0 && (
                <div className="row row-gap-4">
                    {firstRowCards.map(card => (
                        <div key={card.id} className={card.cardColumn ? card.cardColumn : "col-md-6 col-xl-3"}>
                            <CardComponent card={card}/>
                        </div>
                    ))}
                </div>
            )}

            {/* Optional Section Title */}
            {secondRowCards.length > 0 && <h5 className="m-0 mt-5">Detailed Analysis</h5>}

            {/* Second Row */}
            {secondRowCards.length > 0 && (
                <div className="row row-gap-4 mt-3">
                    {secondRowCards.map(card => (
                        <div key={card.id} className={card.cardColumn ? card.cardColumn : "col-md-6 col-xl-4"}>
                            {card.ui === "table" ? (
                                // <h1>hello</h1>
                                <TableComponent card={card}/>
                            ) : (
                                <CardComponent card={card}/>
                            )}
                        </div>
                    ))}
                </div>
            )}
        </>
    );
};

export default FinancialCard;
